"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var moveConversationToFocusedOrOther_1 = require("./conversations/moveConversationToFocusedOrOther");
var moveItemsToFocusedOrOther_1 = require("./items/moveItemsToFocusedOrOther");
function moveMailListRowsToFocusedOrOtherAction(rowKeys, originalTableViewId, actionSource) {
    var tableView = Store_1.default.tableViews.get(originalTableViewId);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            moveConversationToFocusedOrOther_1.default(rowKeys, originalTableViewId, actionSource);
            break;
        case 1 /* Message */:
            moveItemsToFocusedOrOther_1.default(rowKeys, originalTableViewId, actionSource);
            break;
    }
}
exports.default = moveMailListRowsToFocusedOrOtherAction;
//# sourceMappingURL=moveMailListRowsToFocusedOrOther.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/moveMailListRowsToFocusedOrOther.js
// module id = 3826
// module chunks = 62